// Importi del preventivo condivisi fra lista e PDF [sc-48728].

import { totaleSpese } from "./spese";

const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;
const num = (v) => Number(v) || 0;

/**
 * Quanto va restituito al cliente quando ha pagato più del dovuto [sc-48768].
 * Riceve il rimanente (dovuto meno pagato): sotto zero è un credito.
 * Sotto il mezzo centesimo non è un credito: gli arrotondamenti non devono
 * accendere il badge. Il rimborso avviene fuori dal gestionale.
 */
export function daRestituire(rimanente) {
  const r = Number(rimanente);
  if (rimanente === null || !Number.isFinite(r) || r > -0.005) return 0;
  return round2(-r);
}

/**
 * Rimanente del preventivo, stessa formula di `realTotalPrice` nel server:
 * totale − sconto − acconto + maggiorazione. Può andare sotto zero.
 */
export function ricalcolaRimanente(q) {
  if (!q) return 0;
  return round2(
    num(q.totalPrice) -
      num(q.discount) -
      num(q.deposit) +
      num(q.surcharge) +
      // [sc-49299] spese aggiuntive, come realTotalPrice nell'API
      totaleSpese(q)
  );
}

/**
 * Valore massimo di merce consegnabile con un acconto: la metà [sc-49300].
 * Stessa regola nella finestra DDT e nella conferma della consegna parziale.
 */
export function limiteMerceAcconto(acconto) {
  return num(acconto) * 0.5;
}

/**
 * Valore della merce già movimentata con i DDT del preventivo (consegne e
 * ritiri): righe con `movedQty` e `price`, come nella finestra DDT [sc-49300].
 */
export function valoreMerceMossa(righe) {
  return (righe || []).reduce(
    (somma, r) => somma + num(r.movedQty) * num(r.price),
    0
  );
}

/**
 * Con questo acconto si può consegnare almeno un pezzo? [sc-49300]
 * Riceve i prezzi unitari degli articoli del preventivo e il valore della
 * merce già movimentata, che consuma il limite: se anche il pezzo più
 * economico non ci sta, la consegna parziale non può partire.
 * Senza prezzi validi non blocca: decide la finestra DDT.
 */
export function pezzoEntroLimiteAcconto(prezzi, acconto, giaMosso = 0) {
  const validi = (prezzi || []).map(Number).filter(Number.isFinite);
  if (!validi.length) return true;
  return Math.min(...validi) <= limiteMerceAcconto(acconto) - num(giaMosso);
}

// Campi azzerati quando si rimuove un modificatore dal preventivo.
const CAMPI_MODIFICATORE = {
  discount_percent: ["discount", "discount_percent"],
  surcharge_percent: ["surcharge", "surcharge_percent"],
  deposit: ["deposit"],
};

/**
 * Applica al preventivo in lista la rimozione di sconto, maggiorazione o
 * acconto e ricalcola il rimanente, come fa il server [sc-48852].
 * Un tipo sconosciuto non cambia nulla.
 */
export function azzeraModificatore(q, type) {
  const campi = CAMPI_MODIFICATORE[type];
  if (!q || !campi) return q;
  for (const campo of campi) q[campo] = 0;
  q.realTotalPrice = ricalcolaRimanente(q);
  return q;
}

/**
 * Modalità di pagamento da stampare nel PDF [sc-49299]: «Scegli
 * successivamente» è una nota interna, non va al cliente.
 */
export function metodoPagamentoPerPdf(metodo) {
  const m = String(metodo ?? "").trim();
  return m && m !== "Scegli successivamente" ? m : null;
}
